/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CoinAction = {
    EARNED: 'EARNED',
    CANCELLED: 'CANCELLED',
    SPENT: 'SPENT'
} as const;
export type CoinAction = typeof CoinAction[keyof typeof CoinAction];

